import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { combineLatest } from 'rxjs';
import { JwtDecoderService } from '@core/services/jwt-decoder.service';
import { BaseComponent } from '@shared-features/components/base-component/base.component';
import { LanguageEnum } from '@shared/enums/global.enum';
import { NavBarItem } from '@shared/models/nav-bar-item.model';
import { LayoutService } from '@layout/services/layout.service';
import { LanguageService } from '@core/services';
import { UserApi } from '@shared-features/services';
import { NavListService } from '@layout/services/nav-list.service';
// import { ConfigConstant } from '@shared/constants';

@Component({
  selector: 'app-avatar-Menu',
  templateUrl: './avatar-menu.component.html',
  styleUrls: ['./avatar-menu.component.scss'],
})
export class AvatarMenuComponent extends BaseComponent implements OnInit {
  public userFirstName = '';
  public userLastName = '';
  public userEmail = '';

  language = LanguageEnum;
  currentLang: LanguageEnum;
  public navigationItems: NavBarItem[];
  sideMenuActive = false;
  toggleMenu = false;
  position: ConnectedPosition = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  };
  constructor(
    private translateService: TranslateService,
    private authService: UserApi,
    public layoutService: LayoutService,
    private jwtDecoderService: JwtDecoderService,
    private languageService: LanguageService,
    public navService: NavListService
  ) {
    super();
    navService.action$.subscribe((action) => {
      if (action === 'logout') {
        this.logout();
      }
    });
  }

  ngOnInit() {
    this.userFirstName = this.authService.currentUser$.value?.firstName;
    this.userLastName = this.authService.currentUser$.value?.lastName;
    this.userEmail = this.authService.currentUser$.value?.email;
    this.languageService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang.isoCode;
    });

    this.layoutService.websiteDirection$.pipe(takeUntil(this.destroy$)).subscribe((_) => {
      this.setupNavBarItems();
    });
  }

  logout() {
    this.authService.logout().pipe(take(1)).subscribe();
  }

  setLanguage(language: LanguageEnum) {
    this.languageService.changeLanguage(language);
  }

  private setupNavBarItems(): void {
    combineLatest([this.translateService.get(['avatarMenu'])])
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe(([translations]: any) => {
        const { avatarMenu } = translations;

        this.navigationItems = [
          // Customer support menu item hidden for now
          // {
          //   title: `${avatarMenu.CustomerSupport}<small class="d-block text-400">☏ ${ConfigConstant.CUSTOMER_SUPPORT_NUMBER}</small>`,
          //   path: RoutesUtil.SupportAddTicket.url(),
          //   icon: 'headphone',
          //   isVisible: true,
          // },
          // {
          //   title: avatarMenu.MyTickets,
          //   icon: 'bulk-ticket',
          //   isVisible: true,
          //   path: RoutesUtil.SupportTickets.url(),
          // },
          {
            title: avatarMenu.Settings,
            path: RoutesUtil.Settings.url(),
            icon: 'settings',
            isVisible: true,
          },
          {
            title: avatarMenu.logout,
            icon: 'logout',
            action: 'logout',
            isVisible: true,
          },
        ];
      });
  }
}
